<template>
  <div class="center-cmp">
        <!-- <v-chart class="chart" :option="option" autoresize /> -->
         <div id="subcity" style="height: 100%; width: 100%;"></div>
  </div>
</template>

<script>

import axios from 'axios';

export default {
    name: 'LayoutBottom',
    components: {
    },
    provide: {
    },
    props: {
        city: String,
    },
    data() {
        return {
            mapChart: null,
            mapOption: null,
        }
    },
    watch: {
        city: function () {
            this.loadList()
        }
    },
    methods: {
        loadList() {
            var that = this;
            axios.get(this.$store.state.config.host + "/big/sub/?city=" + that.city)
            .then(response => {
                var namelist = []
                var scene = []
                var attendance = []
                Object.values(response.data.data).forEach(element => {
                    namelist.push(element.aname)
                    scene.push(element.scene)
                    attendance.push(element.attendance)
                    
                });
                that.mapOption.xAxis[0].data = namelist;
                that.mapOption.series[0].data = attendance;
                that.mapOption.series[1].data = scene;
                that.mapChart.setOption(that.mapOption, true)

                // console.log(namelist, attendance)
            })
        },
        initMapChart() {
            if (!this.mapChart) {
                this.mapChart = this.$echarts.init(document.getElementById('subcity'))
            }
            this.mapOption = {
            }

            var app = {}
            const posList = [
                'left',
                'right',
                'top',
                'bottom',
                'inside',
                'insideTop',
                'insideLeft',
                'insideRight',
                'insideBottom',
                'insideTopLeft',
                'insideTopRight',
                'insideBottomLeft',
                'insideBottomRight'
            ];
            app.configParameters = {
                rotate: {
                    min: -90,
                    max: 90
                },
                align: {
                    options: {
                        left: 'left',
                        center: 'center',
                        right: 'right'
                    }
                },
                verticalAlign: {
                    options: {
                        top: 'top',
                        middle: 'middle',
                        bottom: 'bottom'
                    }
                },
                position: {
                    options: posList.reduce(function (map, pos) {
                        map[pos] = pos;
                        return map;
                    }, {})
                },
                distance: {
                    min: 0,
                    max: 100
                }
            };

            app.config = {
                rotate: 90,
                align: 'left',
                verticalAlign: 'middle',
                position: 'insideBottom',
                distance: 15,
            };

            const labelOption = {
                show: true,
                position: app.config.position,
                distance: app.config.distance,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                rotate: app.config.rotate,
                formatter: '{c}  {name|{a}}',
                fontSize: 16,
                color: 'rgb(151, 18, 123)',
                rich: {
                    name: {}
                }
            };
            this.mapOption = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: ['人数', '场次']
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: { show: false },
                        data: ['2012', '2013', '2014', '2015', '2016'],
                        axisLabel: {
                            fontSize: 20,
                            color: '#4C63F2'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} 人',
                            color: '#A859FF',
                        }
                    },
                    {
                        type: 'value',
                        // min: 1,
                        // max: 300,
                        position: 'right',
                        axisLabel: {
                            formatter: '{value} 场',
                            color: '#A859FF',
                        }
                    }
                ],
                series: [
                    {
                        name: '人数',
                        type: 'bar',
                        barGap: 0,
                        yAxisIndex: 0,
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        data: [320, 332, 301, 334, 390]
                    },
                    {
                        name: '场次',
                        type: 'bar',
                        label: labelOption,
                        yAxisIndex: 1,
                        emphasis: {
                            focus: 'series'
                        },
                        data: [220, 182, 191, 234, 290]
                    }
                ],
            }

            this.mapChart.setOption(this.mapOption)
        },

        onClick() {
        }
    },
    mounted() {
        this.initMapChart()
        this.loadList()
    },
};

</script>

<style lang="less">
.center-cmp {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: column;

  .cc-header {
    height: 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 30px;
  }

  .cc-details {
    height: 120px;
    display: flex;
    justify-content: center;
    font-size: 32px;
    align-items: center;

    .card {
      background-color: rgba(4,49,128,.6);
      color: #08e5ff;
      height: 70px;
      width: 70px;
      font-size: 45px;
      font-weight: bold;
      line-height: 70px;
      text-align: center;
      margin: 10px;
    }
  }

  .cc-main-container {
    position: relative;
    flex: 1;
    display: flex;

    .ccmc-middle {
      width: 50%;
      height: 90%;

      .active-ring-name {
        font-size: 20px !important;
      }
    }

    .ccmc-left, .ccmc-right {
      width: 25%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 24px;

      span {
        font-size: 40px;
        font-weight: bold;
      }

      .station-info {
        height: 80px;
        display: flex;
        align-items: center;
      }
    }

    .ccmc-left {
      align-items: flex-end;

      span {
        margin-left: 20px;
      }
    }

    .ccmc-right {
      align-items: flex-start;

      span {
        margin-right: 20px;
      }
    }
  }

  .label-tag {
    position: absolute;
    width: 500px;
    height: 30px;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>


